import { useCallback, useEffect, useMemo, useState } from 'react';
import getDcList from '../../api/cars/getDcList';
import Select from '../Select/Select';

// cityId едет в опции: серому дилеру город автомобиля берём из карточки выбранного ДЦ.
const formatOption = (item) => ({ value: item.id, label: item.name, cityId: item.cityId });

// Мультиселект дилерских центров. Опции грузятся из GET /crm/cars/getDcList.
// Можно сузить список по cityId / mark / used (used=true — только АСП, точки БУ-авто). Лейблы для предзаполненных значений
// резолвятся из загруженного списка, даже если в value пришли только id.
const SelectDc = ({
  handleSetSelect,
  handleSetState,
  style,
  cityId,
  mark,
  used,
  allIfUnbound,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Признак «уже спрашивали»: пустой ответ — тоже ответ. Раньше выходили только при непустом списке,
  // и менеджер без привязки к ДЦ гонял запросы бесконечно.
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(() => {
    if (isLoading || loaded) return;
    setIsLoading(true);
    getDcList({ cityId, mark, used, allIfUnbound })
      .then((res) => {
        setOptions((res?.data || []).map(formatOption));
      })
      .finally(() => {
        setIsLoading(false);
        setLoaded(true);
      });
  }, [cityId, mark, used, allIfUnbound, isLoading, loaded]);

  // Грузим список сразу, чтобы резолвить лейблы предзаполненных ДЦ.
  useEffect(() => {
    load();
  }, [load]);

  // Подменяем лейблы выбранных значений на актуальные из загруженного списка.
  // Одиночное значение (авто по договору поручения — ровно один АСП) и
  // предзаполненное defaultValue раньше не резолвились: в карточке машины
  // вместо названия ДЦ показывался его номер, «76».
  const relabel = useCallback(
    (val) => {
      const one = (item) => options.find((o) => o.value === item?.value) || item;
      if (val == null) return val;
      return Array.isArray(val) ? val.map(one) : one(val);
    },
    [options]
  );
  // react-select читает defaultValue один раз при монтировании, а список ДЦ
  // приходит позже — подменённый лейбл до него не доезжает. Поэтому в
  // неуправляемом режиме держим значение сами и отдаём его как value.
  const [inner, setInner] = useState(defaultValue ?? null);
  useEffect(() => {
    setInner(defaultValue ?? null);
  }, [defaultValue]);
  const resolvedValue = useMemo(
    () => relabel(value !== undefined ? value : inner),
    [value, inner, relabel]
  );

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      value={resolvedValue}
      onChange={(val) => {
        setInner(val);
        if (onChange) onChange(val);
      }}
      isMulti
      isSearchable
      isLoading={isLoading}
      onFocus={load}
      title={'Дилерский центр'}
      placeholder={'Выберите из списка'}
      style={style}
      {...props}
    />
  );
};

export default SelectDc;
